import { Box, Button, LinearProgress, Paper, TextField, Typography } from "@mui/material"
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom"
import { MyListApi } from "../utils/restApi";
import { useDispatch } from "react-redux";
import { addNotification } from "../slices/notificationSlice";

export const ForgotPassword = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [searchParams] = useSearchParams();
    const spUsername = searchParams.get('username');
    const spCode = searchParams.get('code');
    const [username, setUsername] = useState(spUsername || '');
    const [code, setCode] = useState(spCode || '');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const sendValidationCode = !spUsername;

    const handleSendCode = () => {
        setLoading(true);
        MyListApi.forgotPasswordRequest(username)
            .then(_ => {
                setLoading(false);
                navigate(`/forgot-password?username=${username}`);
            })
            .catch(error => {
                setLoading(false);
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            });
    }

    const handleChangePassword = () => {
        MyListApi.changePassword(username, code, password)
            .then(_ => {
                setLoading(false);
                navigate(`/login`);
            })
            .catch(error => {
                setLoading(false);
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            });
    }

    return (
        <Paper sx={{ p: '20px', display: 'flex', flexDirection: 'column', gap: '10px', width: '400px', m: 'auto' }}>
            {loading ? <LinearProgress /> : null}
            {(sendValidationCode && !loading)?
                <>
                    <TextField label='Username' value={username} onChange={e => setUsername(e.target.value)} disabled={false} variant="filled" />
                    <Button variant="contained" value={code} onClick={handleSendCode} disabled={!username}>Send Code</Button>
                </>
                :
                <>
                    <TextField label='Username' value={username} disabled={true} variant="filled" onChange={e => setUsername(e.target.value)} />
                    <TextField label='Code' variant="filled" value={code} onChange={e => setCode(e.target.value)} />
                    <TextField label='New Password' variant="filled" value={password} onChange={e => setPassword(e.target.value)} />
                    <Button variant="contained" onClick={handleChangePassword}>Change Password</Button>
                </>
            }
        </Paper>
    );
}